import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"
import { Alert, AlertTitle } from "@mui/material"

const timer = {
  info: true,
  success: true,
}

export default function Toast({ notification: { id, level = "info", title, message, removed }, dismiss }) {
  // We use the offscreen state to know if a notification is entering or exiting the screen
  // A new notification is starting offscreen, so default is true
  const [offscreen, setOffscreen] = useState(true)
  const [hidden, setHidden] = useState(false)

  // This effect serves 2 purposes
  useEffect(() => {
    if (removed) {
      // If we just removed a notification, we want it to transition to offscreen
      setOffscreen(true)
      // We need to hide the element once it has transitioned out,
      // because it might not be cleaned immediately by the parent
      setTimeout(() => setHidden(true), 300)
    } else {
      // If we just added a notification (which will trigger because removed is false for the first time)
      // We want to remove the offscreen state immediately after the first render
      setTimeout(() => setOffscreen(false), 0)
    }
  }, [removed])

  const handleDismiss = event => {
    event.preventDefault()
    dismiss(id)
  }

  return <Alert severity={level} onClose={handleDismiss} className={classnames(`toast toast-${level}`, { offscreen, hidden })}>
    {title && <AlertTitle>{title}</AlertTitle>}
    {message}
    {timer[level] && <div className="timer" />}
  </Alert>
}

Toast.propTypes = {
  dismiss: PropTypes.func.isRequired,
  notification: PropTypes.shape({
    id: PropTypes.string.isRequired,
    level: PropTypes.oneOf(["error", "warning", "info", "success"]),
    title: PropTypes.string,
    message: PropTypes.string.isRequired,
    removed: PropTypes.bool,
  }).isRequired,
}
